"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _TransportDocumentUtil = require("../../utils/TransportDocumentUtil");

var _config = require("../../config");

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TransportDocumentPanel = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(TransportDocumentPanel, _Component);

  function TransportDocumentPanel() {
    (0, _classCallCheck3.default)(this, TransportDocumentPanel);
    return (0, _possibleConstructorReturn3.default)(this, (TransportDocumentPanel.__proto__ || (0, _getPrototypeOf2.default)(TransportDocumentPanel)).apply(this, arguments));
  }

  (0, _createClass3.default)(TransportDocumentPanel, [{
    key: "render",
    value: function render() {
      var transportDocument = this.props.transportDocument;

      return _react2.default.createElement(
        "div",
        { style: styles.container },
        _react2.default.createElement(
          "div",
          { style: styles.topHeader },
          _react2.default.createElement("img", { src: _config2.default.home + "/img/maaporssi-logo-full-color.jpg", style: styles.headerLogo }),
          _react2.default.createElement(
            "div",
            { style: styles.documentNumber },
            "Siirtoasiakirja",
            _react2.default.createElement("br", null),
            "#",
            transportDocument.id
          )
        ),
        _react2.default.createElement("p", { style: styles.clear }),
        _react2.default.createElement(
          "h1",
          { style: styles.header },
          "L\xE4ht\xF6paikka"
        ),
        _react2.default.createElement(
          "div",
          { style: styles.row },
          _react2.default.createElement(
            "span",
            { style: styles.label },
            "Urakoitsija"
          ),
          _react2.default.createElement(
            "span",
            { style: styles.value },
            transportDocument.supplier.contractor
          )
        ),
        _react2.default.createElement(
          "div",
          { style: styles.row },
          _react2.default.createElement(
            "span",
            { style: styles.label },
            "P\xE4iv\xE4m\xE4\xE4r\xE4"
          ),
          _react2.default.createElement(
            "span",
            { style: styles.value },
            (0, _TransportDocumentUtil.formatTransportDate)(transportDocument.loading_start_time)
          )
        ),
        _react2.default.createElement(
          "div",
          { style: styles.row },
          _react2.default.createElement(
            "span",
            { style: styles.label },
            "EWC-koodi"
          ),
          _react2.default.createElement(
            "span",
            { style: styles.value },
            transportDocument.soil.ewc_code_code,
            "\xA0",
            transportDocument.soil.ewc_code_name
          )
        ),
        _react2.default.createElement(
          "div",
          { style: styles.row },
          _react2.default.createElement(
            "span",
            { style: styles.label },
            "Ty\xF6numero"
          ),
          _react2.default.createElement(
            "span",
            { style: styles.value },
            transportDocument.work_number
          )
        ),
        _react2.default.createElement(
          "div",
          { style: styles.row },
          _react2.default.createElement(
            "span",
            { style: styles.label },
            "Aineksen tyyppi"
          ),
          _react2.default.createElement(
            "span",
            { style: styles.value },
            transportDocument.soil.soil_type_name
          )
        ),
        _react2.default.createElement(
          "div",
          { style: styles.row },
          _react2.default.createElement(
            "span",
            { style: styles.label },
            "Aineksen m\xE4\xE4r\xE4 (t)"
          ),
          _react2.default.createElement(
            "span",
            { style: styles.value },
            transportDocument.soil.amount
          )
        ),
        _react2.default.createElement(
          "div",
          { style: styles.row },
          _react2.default.createElement(
            "span",
            { style: styles.label },
            "Kuljetusmatka (km)"
          ),
          _react2.default.createElement(
            "span",
            { style: styles.value },
            (0, _TransportDocumentUtil.formatRouteLength)(transportDocument)
          )
        ),
        _react2.default.createElement(
          "div",
          { style: styles.row },
          _react2.default.createElement(
            "span",
            { style: styles.label },
            "Osoite"
          ),
          _react2.default.createElement(
            "span",
            { style: styles.value },
            transportDocument.supplier.address,
            ",",
            transportDocument.supplier.postal_code,
            transportDocument.supplier.postal_area
          )
        ),
        _react2.default.createElement(
          "div",
          { style: styles.row },
          _react2.default.createElement(
            "span",
            { style: styles.label },
            "Yhteyshenkil\xF6"
          ),
          _react2.default.createElement(
            "span",
            { style: styles.value },
            transportDocument.supplier.contact_person_name
          )
        ),
        _react2.default.createElement(
          "div",
          { style: styles.row },
          _react2.default.createElement(
            "span",
            { style: styles.label },
            "\xA0"
          ),
          _react2.default.createElement(
            "span",
            { style: styles.value },
            transportDocument.supplier.contact_person_email
          )
        ),
        _react2.default.createElement(
          "div",
          { style: styles.row },
          _react2.default.createElement(
            "span",
            { style: styles.label },
            "\xA0"
          ),
          _react2.default.createElement(
            "span",
            { style: styles.value },
            transportDocument.supplier.contact_person_phone
          )
        ),
        _react2.default.createElement(
          "h1",
          { style: styles.header },
          "Vastaanottaja"
        ),
        _react2.default.createElement(
          "div",
          { style: styles.row },
          _react2.default.createElement(
            "span",
            { style: styles.label },
            "Yritys"
          ),
          _react2.default.createElement(
            "span",
            { style: styles.value },
            transportDocument.receiver.contractor
          )
        ),
        _react2.default.createElement(
          "div",
          { style: styles.row },
          _react2.default.createElement(
            "span",
            { style: styles.label },
            "Osoite"
          ),
          _react2.default.createElement(
            "span",
            { style: styles.value },
            transportDocument.receiver.address,
            ",\xA0",
            transportDocument.receiver.postal_code,
            "\xA0",
            transportDocument.receiver.postal_area
          )
        ),
        _react2.default.createElement(
          "div",
          { style: styles.row },
          _react2.default.createElement(
            "span",
            { style: styles.label },
            "Yhteyshenkil\xF6"
          ),
          _react2.default.createElement(
            "span",
            { style: styles.value },
            transportDocument.receiver.contact_person_name
          )
        ),
        _react2.default.createElement(
          "div",
          { style: styles.row },
          _react2.default.createElement(
            "span",
            { style: styles.label },
            "\xA0"
          ),
          _react2.default.createElement(
            "span",
            { style: styles.value },
            transportDocument.receiver.contact_person_email
          )
        ),
        _react2.default.createElement(
          "div",
          { style: styles.row },
          _react2.default.createElement(
            "span",
            { style: styles.label },
            "\xA0"
          ),
          _react2.default.createElement(
            "span",
            { style: styles.value },
            transportDocument.receiver.contact_person_phone
          )
        ),
        _react2.default.createElement(
          "h1",
          { style: styles.header },
          "Kuljetus"
        ),
        _react2.default.createElement(
          "div",
          { style: styles.row },
          _react2.default.createElement(
            "span",
            { style: styles.label },
            "Kuljettaja"
          ),
          _react2.default.createElement(
            "span",
            { style: styles.value },
            transportDocument.user.first_name,
            " ",
            transportDocument.user.last_name
          )
        ),
        _react2.default.createElement(
          "div",
          { style: styles.row },
          _react2.default.createElement(
            "span",
            { style: styles.label },
            "Yritys"
          ),
          _react2.default.createElement(
            "span",
            { style: styles.value },
            transportDocument.company.name
          )
        ),
        _react2.default.createElement(
          "div",
          { style: styles.row },
          _react2.default.createElement(
            "span",
            { style: styles.label },
            "Y-tunnus"
          ),
          _react2.default.createElement(
            "span",
            { style: styles.value },
            transportDocument.company.business_id
          )
        ),
        _react2.default.createElement(
          "div",
          { style: styles.row },
          _react2.default.createElement(
            "span",
            { style: styles.label },
            "Osoite"
          ),
          _react2.default.createElement(
            "span",
            { style: styles.value },
            transportDocument.company.street_address,
            ",\xA0",
            transportDocument.company.postal_code,
            "\xA0",
            transportDocument.company.postal_area
          )
        ),
        _react2.default.createElement(
          "h1",
          { style: styles.header },
          "Ajoneuvo"
        ),
        _react2.default.createElement(
          "div",
          { style: styles.row },
          _react2.default.createElement(
            "span",
            { style: styles.label },
            "Rekisterinumero"
          ),
          _react2.default.createElement(
            "span",
            { style: styles.value },
            transportDocument.car.register_number
          )
        ),
        _react2.default.createElement(
          "div",
          { style: styles.row },
          _react2.default.createElement(
            "span",
            { style: styles.label },
            "Akselit"
          ),
          _react2.default.createElement(
            "span",
            { style: styles.value },
            (0, _TransportDocumentUtil.getCarType)(transportDocument.car.car_type)
          )
        ),
        _react2.default.createElement(
          "div",
          { style: styles.link },
          "www.maaporssi.fi"
        )
      );
    }
  }]);
  return TransportDocumentPanel;
}(_react.Component), _class.propTypes = {
  transportDocument: _react.PropTypes.object.isRequired
}, _temp);
exports.default = TransportDocumentPanel;


var styles = {
  container: {
    background: "#fff",
    color: "#000",
    fontSize: 12,
    fontFamily: '"Lato Light", Helvetica, sans-serif',
    paddingLeft: 60
  },
  header: {
    background: "#fff",
    color: "#fb761d",
    fontSize: 14,
    fontFamily: "Lato, Helvetica, sans-serif",
    paddingTop: "20px"
  },
  label: {
    width: "200px",
    float: "left"
  },
  row: {
    overflow: "hidden",
    width: "100%"
  },
  link: {
    fontSize: 20,
    textAlign: "center",
    paddingTop: 40
  },
  headerLogo: {
    width: "150px",
    padding: "20px 0",
    textAlign: "left",
    float: "left",
    clear: "both"
  },
  topHeader: {
    color: "#fb761d",
    width: "100%",
    paddingBottom: "80px"
  },
  documentNumber: {
    textAlign: "right",
    padding: "20px 60px"
  },
  clear: {
    clear: "both"
  }

};
module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/print/TransportDocumentPanel.js
 ** module id = 1171
 ** module chunks = 0
 **/